import { ExternalStyles, focusBoxShadow, Theme, useStyles } from 'bold-ui'
import { css } from 'emotion'
import React, { CSSProperties } from 'react'
import { AccordionItemButton } from 'react-accessible-accordion'

export interface AccordionButton {
  children?: React.ReactNode
  style?: ExternalStyles
}

export function AccordionButton(props: AccordionButton) {
  const { children, style } = props
  const { classes } = useStyles(createStyles, props)

  return (
    <div style={{ paddingBottom: '0.3rem' }}>
      <AccordionItemButton className={css(classes.content, style)}>{children}</AccordionItemButton>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  content: {
    cursor: 'pointer',
    borderRadius: `${theme.radius.input}px`,
    margin: '0.3rem',
    '&:hover': {
      borderColor: theme.pallete.gray.c50,
      backgroundColor: theme.pallete.surface.background,
    },
    '&:focus': {
      outline: 'none',
      boxShadow: focusBoxShadow(theme, 'primary'),
      transitionProperty: 'box-shadow',
      transitionDuration: '.2s',
    },
    '&[aria-expanded="true"] div:first-child > svg': {
      transform: 'rotate(180deg)',
      transition: '0.4s',
    },
    '&[aria-expanded="false"] div:first-child > svg': {
      transform: 'rotate(0deg)',
      transition: '0.4s',
    },
  } as CSSProperties,
})
